export default function () {
    tabChangeEvent();
}

function toggleActive(b) {
    const activeTab = $('a.menu-topbar__link.--active').data('tabkey') || $('a.menu-topbar__link.--active').text();
    const activePane = $(`[data-view="${activeTab}"]`);
    $('.tab[data-view]').hide();
    activePane.toggle(b);
    $(document).trigger('on:TabChange');
}

const tabChangeEvent = () => {
    $('a.menu-topbar__link').on('click', function () {
        $('a.menu-topbar__link.--active').removeClass('--active').parent().removeClass('--active');
        $(this).addClass('--active').parent().addClass('--active');

        toggleActive(true);
    });
}